import { Shield, Smartphone, Mail, Loader, ArrowLeft } from 'lucide-react';

/**
 * Two-factor authentication verification screen — supports
 * TOTP (authenticator app) and email-based 2FA methods.
 */
function TwoFactorForm({
    twoFactorCode,
    setTwoFactorCode,
    twoFactorMethod,
    twoFactorMessage,
    error,
    isLoading,
    onSubmit,
    onBack
}) {
    return (
        <>
            <button
                type="button"
                onClick={onBack}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-1)',
                    padding: 0,
                    marginBottom: 'var(--spacing-4)',
                    fontSize: 'var(--font-size-sm)'
                }}
            >
                <ArrowLeft size={16} />
                Back to login
            </button>

            <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-6)' }}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: 'var(--radius-full)',
                    background: twoFactorMethod === 'totp'
                        ? 'linear-gradient(135deg, color-mix(in srgb, var(--accent-primary) 20%, transparent), color-mix(in srgb, var(--accent-blue) 20%, transparent))'
                        : 'linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(6, 182, 212, 0.2))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto var(--spacing-4)'
                }}>
                    {twoFactorMethod === 'totp' ? (
                        <Smartphone size={28} style={{ color: 'var(--accent-purple)' }} />
                    ) : (
                        <Mail size={28} style={{ color: 'var(--accent-blue)' }} />
                    )}
                </div>
                <h2 style={{
                    fontSize: 'var(--font-size-xl)',
                    fontWeight: 600,
                    marginBottom: 'var(--spacing-2)'
                }}>
                    {twoFactorMethod === 'totp' ? 'Authenticator Code' : 'Check Your Email'}
                </h2>
                <p style={{
                    color: 'var(--text-secondary)',
                    fontSize: 'var(--font-size-sm)'
                }}>
                    {twoFactorMessage}
                </p>
            </div>

            {error && (
                <div style={{
                    padding: 'var(--spacing-3)',
                    background: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid var(--error)',
                    borderRadius: 'var(--radius-md)',
                    color: 'var(--error)',
                    fontSize: 'var(--font-size-sm)',
                    marginBottom: 'var(--spacing-4)'
                }}>
                    {error}
                </div>
            )}

            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Enter 6-digit code"
                        value={twoFactorCode}
                        onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 8))}
                        autoFocus
                        style={{
                            textAlign: 'center',
                            fontSize: 'var(--font-size-2xl)',
                            letterSpacing: '8px',
                            fontFamily: 'monospace',
                            padding: 'var(--spacing-4)'
                        }}
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading || twoFactorCode.length < 6}
                    style={{
                        width: '100%',
                        padding: 'var(--spacing-3)',
                        marginTop: 'var(--spacing-2)'
                    }}
                >
                    {isLoading ? (
                        <>
                            <Loader size={18} className="spin" style={{ animation: 'spin 1s linear infinite' }} />
                            Verifying...
                        </>
                    ) : (
                        <>
                            <Shield size={18} />
                            Verify & Sign In
                        </>
                    )}
                </button>
            </form>

            {twoFactorMethod === 'totp' && (
                <p style={{
                    textAlign: 'center',
                    fontSize: 'var(--font-size-xs)',
                    color: 'var(--text-tertiary)',
                    marginTop: 'var(--spacing-4)'
                }}>
                    Lost your device? Use a backup code instead.
                </p>
            )}
        </>
    );
}

export default TwoFactorForm;
